import { useTranslation } from '@crehana/i18n';
import Star from '@crehana/icons/Star';
import Users from '@crehana/icons/Users';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Clamp, colors, LazyImage, PrimaryButton } from '@crehana/ui';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

import type { GetSkillXQResults_skillsB2BUserResult_resultSkill_recommendedCourses as CourseType } from '@/views/B2BSkillXP/graphql/types/GetSkillXQResults';

const EnrollmentsWrapper = styled.div`
  background: ${({ theme }) =>
    `linear-gradient(-360deg, ${theme.colors.base.main} 0%, rgba(24, 27, 50, 0) 100%)`};
`;

const { white, yellowMain } = colors;

const Coursecard = ({ course }: { course: CourseType }) => {
  const { t } = useTranslation();
  const {
    title,
    enrollmentUrl,
    description,
    promoImage,
    imagePlaceholder,
    enrollments,
    url,
    professor,
    score,
  } = course;

  return (
    <div className="rounded-5 hover:shadow-dropdown" data-testid="course-card">
      <div
        onKeyPress={() => {
          if (url) {
            window.location.href = url;
          }
        }}
        className="relative cursor-pointer"
        onClick={() => {
          if (url) {
            window.location.href = url;
          }
        }}
      >
        <LazyImage
          placeholder={imagePlaceholder || ''}
          className="w-full h-160 relative cursor-pointer rounded-t-5"
          imgClassName="object-cover"
          src={promoImage || ''}
          imgxParams={{ h: 160, dpr: 2, crop: 'faces' }}
          alt={title || ''}
        />
        <EnrollmentsWrapper className="flex w-full px-12 pb-8 absolute bottom-0 justify-between font-caption text-white tw-font-semibold">
          <span className="flex items-center">
            <Users size={16} className="mr-4" color={white} /> {enrollments}
            &nbsp; Estudiantes
          </span>
          <span className="flex items-center">
            <Star size={16} color={yellowMain} className="mr-4" />{' '}
            {score?.average || 4.6}
          </span>
        </EnrollmentsWrapper>
      </div>
      <section className="p-16 w-full bg-base-light-dark-mode">
        <div>
          <Clamp clamp={2} className="font-subtitle3 h-40 text-white mb-8">
            {title}
          </Clamp>
          <span className="font-body4 text-white">
            Por: {professor?.fullName}
          </span>
          <Clamp clamp={2} className="font-body4 text-gray-dark mt-8">
            {description}
          </Clamp>
        </div>
        {enrollmentUrl && (
          <PrimaryButton
            isDark
            className="w-full mt-16"
            label={t('ENROLLMENT_CTA')}
            onClick={() => {
              window.location.href = enrollmentUrl;
            }}
          />
        )}
      </section>
    </div>
  );
};

export default Coursecard;
